import { cookieConsentJs } from "./cookie-consent"

export const initVendors = () => { 

    cookieConsentJs.init();

}